<template>
	<div v-if="getSubscription" :class="buttonClass" @click="handleSubscription">
		<!-- PC版本 -->
		<template v-if="mode === 'pc'">
			<SvgIcons name="icon_message" class="c-action-svg" />
			<span class="action-block-span">{{ getModuleName('message_subscription') }}</span>
		</template>

		<!-- 移动端版本 -->
		<template v-else>
			<SvgIcons name="icon_message" class="mobile-action-svg" />
		</template>

		<CTeleport to="#app">
			<!-- 消息订阅组件 -->
			<ActionSubscription ref="subscriptionRef" />
		</CTeleport>
	</div>
</template>

<script setup>
import { ref, inject } from 'vue';
import { useModuleDisplay } from '../hooks/useModuleDisplay.js';
import { debounce } from '@/utils/api';
import ActionSubscription from '@/rebuild/components/subscription/index.vue';

const mode = inject('mode');
const buttonClass = inject('roundButtonClass');

const { getSubscription, getModuleName, trackAction } = useModuleDisplay();

// 订阅组件引用
const subscriptionRef = ref(null);

// 点击处理
const handleSubscription = debounce(
	() => {
		trackAction('subscription');
		subscriptionRef.value?.open({ mode });
	},
	200,
	true
);
</script>
